
import React from 'react';
import AnimatedSection from '../../../components/base/AnimatedSection';

const WhyFailSection = () => {
  return (
    <AnimatedSection className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#394851] mb-6">
            Why everything else fails
          </h2>
          <p className="text-xl text-[#748881] max-w-3xl mx-auto leading-relaxed">
            Most copywriters either sound like robots or manipulate people. What you need is someone who understands your audience the way Claude Hopkins understood his.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-semibold text-[#394851] mb-8">
              The problem with most copywriters:
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-line text-red-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#394851] mb-2">
                    They sound like robots
                  </h4>
                  <p className="text-[#748881]">
                    "We are passionate about delivering best-in-class solutions that revolutionize your synergy." 
                    Nobody talks like that. Nobody buys from that.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-line text-red-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#394851] mb-2">
                    They manipulate instead of serve
                  </h4>
                  <p className="text-[#748881]">
                    Fake urgency. False scarcity. Psychological tricks that make people feel dirty after buying. 
                    That's not copywriting—that's manipulation.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-line text-red-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#394851] mb-2">
                    AI-generated copy screams "fake"
                  </h4>
                  <p className="text-[#748881]">
                    Your customers can smell AI copy from a mile away. It's generic, soulless, and makes you sound like everyone else who used the same prompt.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-line text-red-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#394851] mb-2">
                    Big agencies don't understand Main Street
                  </h4>
                  <p className="text-[#748881]">
                    They're great at spending your money on corporate-speak that works for Fortune 500 companies. 
                    But your customers aren't corporate executives—they're real people with real problems.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#A8AE9C]/10 to-[#748881]/10 rounded-lg p-8">
            <h3 className="text-2xl font-semibold text-[#394851] mb-6">
              What you actually need:
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-[#A8AE9C] rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-[#748881]">Someone who understands your audience like Claude Hopkins understood his</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-[#A8AE9C] rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-[#748881]">Someone who refuses to settle for mediocrity</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-[#A8AE9C] rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-[#748881]">Someone who treats this like a sacred trust—not a transaction</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-[#A8AE9C] rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-[#748881]">Someone who believes copy should serve people, never manipulate them</p>
              </div>
            </div>

            <div className="mt-8 p-6 bg-[#394851] text-white rounded-lg">
              <p className="text-lg italic text-center">
                "Copy is sacred. It either serves people or manipulates them. We refuse the latter."
              </p>
              <p className="text-[#A8AE9C] text-center mt-2 font-medium">
                — Sebastian, The Pilot Copy
              </p>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default WhyFailSection;
